export const DAMAGE_NUMBER_LIFETIME_MS = 800;
export const DAMAGE_NUMBER_FONT_SIZE = 15;

export const DAMAGE_NUMBER_RISE_SPEED = 60;

export const DAMAGE_NUMBER_SCATTER = 40;

export const DAMAGE_NUMBER_COLORS = { heal: '#66CD00', damage: '#CD2626' } as const;

export interface DamageNumber {
  readonly x: number;
  readonly y: number;
  readonly amount: number;
  readonly at: number;
}

export function damageNumberAlpha(ageMs: number): number {
  const remaining = DAMAGE_NUMBER_LIFETIME_MS - ageMs;
  return Math.max(0, Math.min(1, remaining / (DAMAGE_NUMBER_LIFETIME_MS / 2)));
}

export class DamageNumberField {
  private readonly live: DamageNumber[] = [];

  get all(): readonly DamageNumber[] {
    return this.live;
  }

  get count(): number {
    return this.live.length;
  }

  add(x: number, y: number, amount: number, now: number): void {
    if (amount === 0) return;
    this.live.push({ x, y, amount, at: now });
  }

  advance(now: number): void {
    let write = 0;
    for (const number of this.live) {
      if (now > number.at + DAMAGE_NUMBER_LIFETIME_MS) continue;
      this.live[write++] = number;
    }
    this.live.length = write;
  }

  clear(): void {
    this.live.length = 0;
  }
}

export function damageNumberScatter(entityId: number, at: number): readonly [number, number] {
  const seed = (entityId * 2654435761 + at) >>> 0;
  const inRange = (v: number): number =>
    (v % (DAMAGE_NUMBER_SCATTER * 2 + 1)) - DAMAGE_NUMBER_SCATTER;
  return [inRange(seed), inRange(seed >>> 8)];
}
